import { HttpErrorResponse } from "@angular/common/http";
import { Message } from 'primeng/components/common/api';
import { BBAPIError } from '../carrier/api-error';
import { TimeoutError } from "rxjs";

export class ErrorHandler {

    public handleError(error) {
        let message: Message;

        if (error instanceof TimeoutError) {
            message = { severity: 'error', summary: error.name, detail: error.message };

        } else if (error instanceof HttpErrorResponse) {
            // Here we get the normal HTTP Error response
            switch (error.status) {
                case 400:
                    message = { severity: 'error', summary: 'Bad Request', detail: 'Backend has a problem.' };
                    break;
                case 401:
                    message = { severity: 'error', summary: 'Authentication failed', detail: 'Wrong username or password' };
                    break;
                case 404:
                    message = { severity: 'error', summary: 'API not found', detail: 'Backend not found.' };
                    break;
                case 405:
                    message = { severity: 'error', summary: 'Method not Allowed', detail: 'Backend has a problem.' };
                    break;
                case 409:
                    message = { severity: 'error', summary: 'Conflict', detail: 'Backend has a problem.' };
                    break;
                case 422:
                    message = { severity: 'error', summary: 'Unprocessable Entity', detail: 'Data has a problem.' };
                    break;
                case 424:
                    message = { severity: 'error', summary: 'Failed dependency', detail: 'Required Backend Service not found.' };
                    break;
                case 500:
                    message = { severity: 'error', summary: 'Internal Server error', detail: 'An unknown error occured.' };
                    break;
                case 504:
                case 0:
                    message = { severity: 'error', summary: 'Can not connect to service!', detail: 'Service is down, Please contact support!' };
                    break;
                default:
                    message = { severity: 'error', summary: 'Unknown error', detail: 'An unknown error occured.' };
                    break;
            }
            // Here we look for a very specific error from the API itself
            if (error.error.bbApiError) {
                error.error.bbApiError.message ? message.detail = error.error.bbApiError.message : message.detail = error.error.bbApiError.title;
                if(error.error.bbApiError.title) {
                    message.summary = error.error.bbApiError.title;
                } 
                if("Default LibType Error" == error.error.bbApiError.title || "Carrier not found" == error.error.bbApiError.title){
                    message.summary=error.error.bbApiError.title;
                }
            }
        } else {
            message = { severity: 'error', summary: 'Unknown error', detail: 'Error that has yet to be defined. This should not happen.' };
        }

       

        console.log(message);
        return message;
    }

    public handleBBApiErrors(bbApiError: BBAPIError) {
        let messages: Message[] = [];
        bbApiError.errors.forEach(
            errorElement => {
                if(errorElement.code){
                    messages.push({ severity: 'error', detail: errorElement.message, summary:errorElement.code });
                }else{
                    messages.push({ severity: 'error', detail: errorElement.message });
                }
            }
        )
        return messages;
    }

    public isOptimisticLockException(error: any): boolean {
        if (error instanceof HttpErrorResponse && error.status === 423) {
            return true;
        }else{
            return false;
        }
    }
}  